import React from 'react';
export function Privacy() {
  return <div className="pt-10 pb-20" data-id="element-399" data-mp="lkqjopcwwfoc">
      <div className="bg-gray-50 py-16 mb-12" data-id="element-400" data-mp="2wjowabb40wyv">
        <div className="container-custom" data-id="element-401" data-mp="2wkzw601fpkkp">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-402" data-mp="2whuakus0l0tq">
            Privacy Policy
          </h1>
          <p className="text-gray-600" data-id="element-403" data-mp="36huw8ndcvt13">Last Updated: January 2024</p>
        </div>
      </div>

      <div className="container-custom max-w-4xl" data-id="element-404" data-mp="3k99f8u79ju85">
        <div className="prose prose-blue max-w-none text-gray-700" data-id="element-405" data-mp="3k7y9wpy66eex">
          <h3 data-id="element-406" data-mp="3faof0us0hajp">1. Introduction</h3>
          <p data-id="element-407" data-mp="3f9n18ijm29ya">
            Brixen Consulting FZCO ("we," "us," or "our") respects your privacy
            and is committed to protecting your personal data. This Privacy
            Policy explains how we collect, use, and safeguard your information
            when you visit our website or use our services.
          </p>

          <h3 data-id="element-408" data-mp="1zvilf6nlh8c5">2. Information We Collect</h3>
          <p data-id="element-409" data-mp="1uv37acvhnwt4">We may collect the following types of information:</p>
          <ul data-id="element-410" data-mp="1uwnz3uqf51na">
            <li data-id="element-411" data-mp="h2ftfv7crofr">
              <strong data-id="element-412" data-mp="h2z0ggvgssf0">Personal Identification Information:</strong> Name, email
              address, phone number, company name, and job title.
            </li>
            <li data-id="element-413" data-mp="l1es4y2hqoyr">
              <strong data-id="element-414" data-mp="q346onox9krl">Business Information:</strong> Details about your business
              activities, requirements, and documentation provided for service
              execution.
            </li>
            <li data-id="element-415" data-mp="zsxfxi1ldnso">
              <strong data-id="element-416" data-mp="ztgoi85cqzu1">Usage Data:</strong> Information about how you use our
              website, including IP address, browser type, and pages visited.
            </li>
          </ul>

          <h3 data-id="element-417" data-mp="18su1hasoq6ji">3. How We Use Your Information</h3>
          <p data-id="element-418" data-mp="18u53b52kl47z">We use your data for the following purposes:</p>
          <ul data-id="element-419" data-mp="1dsot5gkab05m">
            <li data-id="element-420" data-mp="1dr5axkf2if17">To provide and manage our corporate services.</li>
            <li data-id="element-421" data-mp="3akyrggqmitrl">
              To communicate with you regarding your inquiries and service
              updates.
            </li>
            <li data-id="element-422" data-mp="3fkl1yif2hvwp">
              To comply with legal and regulatory obligations (e.g., KYC/AML
              checks).
            </li>
            <li data-id="element-423" data-mp="mrfipmzkv2ut">To improve our website and customer experience.</li>
          </ul>

          <h3 data-id="element-424" data-mp="hs2uoywyzpqn">4. Legal Basis for Processing</h3>
          <p data-id="element-425" data-mp="vprd803keksj">We process your personal data based on:</p>
          <ul data-id="element-426" data-mp="vraxs2w97i04">
            <li data-id="element-427" data-mp="vnn330f2opjt">
              <strong data-id="element-428" data-mp="qr6fc7bscd79">Consent:</strong> When you voluntarily provide information
              via contact forms.
            </li>
            <li data-id="element-429" data-mp="15n5kpa7ifz8p">
              <strong data-id="element-430" data-mp="15mmcwmbkqr8e">Contractual Necessity:</strong> To fulfill our service
              agreement with you.
            </li>
            <li data-id="element-431" data-mp="10mzwy54d2wvw">
              <strong data-id="element-432" data-mp="1eghgvr0ymbmg">Legal Obligation:</strong> To comply with UAE laws and
              regulations.
            </li>
            <li data-id="element-433" data-mp="1aedwgcwbbwp1">
              <strong data-id="element-434" data-mp="1afypfy2zb7ks">Legitimate Interests:</strong> For business administration
              and improvement.
            </li>
          </ul>

          <h3 data-id="element-435" data-mp="1ockgoq8c9y68">5. Cookies</h3>
          <p data-id="element-436" data-mp="1jfu1s689t8me">
            Our website uses cookies to enhance your browsing experience. You
            can choose to disable cookies through your browser settings, but
            this may affect the functionality of the site.
          </p>

          <h3 data-id="element-437" data-mp="27zyl3bnkfy2e">6. Data Sharing</h3>
          <p data-id="element-438" data-mp="27y47kiemj88c">
            We do not sell your personal data. We may share your information
            with:
          </p>
          <ul data-id="element-439" data-mp="1y1rhrvm79eiv">
            <li data-id="element-440" data-mp="1y1ho9y1y4p8f">
              Government authorities and free zone regulators as required for
              company setup.
            </li>
            <li data-id="element-441" data-mp="1k8t60ypg99t5">
              Trusted third-party service providers (e.g., banking partners,
              auditors) with your consent.
            </li>
            <li data-id="element-442" data-mp="1adhrohhye4lx">Legal authorities if required by law.</li>
          </ul>

          <h3 data-id="element-443" data-mp="1fbjk3t19rga2">7. International Transfers</h3>
          <p data-id="element-444" data-mp="1fckwq1xxoatw">
            Your information may be transferred to and processed in countries
            other than your country of residence. We ensure appropriate
            safeguards are in place for such transfers.
          </p>

          <h3 data-id="element-445" data-mp="15fg7tucpe19e">8. Data Retention</h3>
          <p data-id="element-446" data-mp="yaynlbbnsnck">
            We retain your personal data only for as long as necessary to
            fulfill the purposes for which it was collected, including for the
            purposes of satisfying any legal, accounting, or reporting
            requirements.
          </p>

          <h3 data-id="element-447" data-mp="jlizy47fcy13">9. Data Security</h3>
          <p data-id="element-448" data-mp="jkhmjt2xrzg7">
            We implement appropriate technical and organizational measures to
            protect your personal data against unauthorized access, alteration,
            disclosure, or destruction.
          </p>

          <h3 data-id="element-449" data-mp="ajjd2v9qazq8">10. Your Rights</h3>
          <p data-id="element-450" data-mp="5lrkdz19f9kz">You have the right to:</p>
          <ul data-id="element-451" data-mp="5mt2gngp0wc7">
            <li data-id="element-452" data-mp="5m9qrohmz46m">Access your personal data.</li>
            <li data-id="element-453" data-mp="mwte9t52eps">Request correction of inaccurate data.</li>
            <li data-id="element-454" data-mp="ohpw4z0k7qa">
              Request deletion of your data (subject to legal retention
              requirements).
            </li>
            <li data-id="element-455" data-mp="1v0oafudss0v9">Withdraw consent where applicable.</li>
          </ul>

          <h3 data-id="element-456" data-mp="1uyld0pabf5gi">11. Contact Us</h3>
          <p data-id="element-457" data-mp="23hydxtz085ah">
            If you have any questions about this Privacy Policy or wish to
            exercise your rights, please contact us at:
            <br data-id="element-458" data-mp="27hqr6jzcezm6" />
            <strong data-id="element-459" data-mp="27h78h11vc773">Email:</strong> info@brixenconsulting.com
          </p>
        </div>
      </div>
    </div>;
}